import InputField from "../../formFields/inputField"

function RenderInput(props) {
  const fullWidth = props.fullWidth ?? true
  const margin = props.margin ?? "medium"
  const variant = props.variant ?? "outlined"

  return <InputField {...props} fullWidth={fullWidth} margin={margin} variant={variant} />
}

export default RenderInput
